//Data Actions

//Load the Sourcing Change Data
export const loadDataAction = (payload = []) => ({
    type : 'LOAD_DATA',
    payload
});
//Load the raw data returned by the search API
export const loadCacheDataAction = (payload) => ({
    type : 'LOAD_CACHE_SEARCH_DATA',
    payload
});

//Set data cached state to determine if data cached on server
export const setDataCachedAction = (dataCached) => ({
    type : 'SET_DATA_CACHED',
    dataCached
});

//Set the table page size when user changes it in the app
export const setTablePageSizeAction = (pageSize) => ({
    type : 'SET_PAGE_SIZE',
    pageSize
});

//Set the table page index when the user changes it in the app
export const setTablePageIndexAction = (pageIndex) => ({
    type : 'SET_PAGE_INDEX',
    pageIndex
});

export const setTablePageOffsetAction = (pageOffset) => ({
    type : 'SET_PAGE_OFFSET',
    pageOffset
});

export const setRowCount = (rowCount) => ({
    type : 'SET_ROW_COUNT',
    rowCount
});

export const setNewSearchAction = (isNewSearched) => ({
    type : 'SET_NEW_SEARCH',
    isNewSearched
});




// WEBPACK FOOTER //
// ./src/Actions/data.js